export const telegramVideoModalName = 'telegram-video';
